import {AnimationGlobalEnum} from './animation-global.enum';

//#region ENUM AnimationIterationCountEnum

/**
 * ### AnimationIterationCountEnum
 * Enum representing possible values for the CSS `animation-iteration-count` property.
 *
 * This enum is accompanied by:
 * - `AnimationIterationCountEnumType` — a union type of all enum keys.
 *
 * @enum AnimationIterationCountEnum
 * @property INFINITE - The animation will repeat forever.
 */
export enum AnimationIterationCountEnum {
  /** The animation will repeat forever. */
  INFINITE = 'infinite',
}

//#endregion

//#region TYPE AnimationIterationCountEnumType
/**
 * ### AnimationIterationCountEnumType
 * Union type of all keys in `AnimationIterationCountEnum`.
 *
 * @type AnimationIterationCountEnumType
 * @example
 * // Possible values: 'INFINITE'
 */
export type AnimationIterationCountEnumType = keyof typeof AnimationIterationCountEnum;
//#endregion

//#region TYPE AnimationIterationCountType
/**
 * ### AnimationIterationCountType
 * Union type for CSS `animation-iteration-count` values.
 *
 * This type includes:
 * - Numeric values representing the number of iterations.
 * - Keys from `AnimationIterationCountEnum` (e.g., 'INFINITE').
 * - Keys from `AnimationGlobalEnum` (e.g., 'INHERIT', 'INITIAL', etc.).
 *
 * @type AnimationIterationCountType
 * @example
 * // Possible values:
 * // 1, 2, 3, ... | 'INFINITE' | 'INHERIT' | 'INITIAL' | 'REVERT' | 'REVERT_LAYER' | 'UNSET'
 */
export type AnimationIterationCountType =
  | number
  | keyof typeof AnimationIterationCountEnum
  | keyof typeof AnimationGlobalEnum;
//#endregion
